/* global OfficeRuntime */

import { handleClientSideErrors } from "./error-handler";
import { getAccessTokenViaDialog } from "./fallbackauthdialog";

interface MiddletierTokenOptions {
  // Claims string returned by the middle tier when AAD requires an additional form of authentication (MFA).
  authChallenge?: string;
  // When false, never opens the fallback login dialog (use for background calls).
  interactive?: boolean;
}

// Set once Office SSO failed with an error that requires the fallback dialog, so later calls
// skip the failing SSO round trip.
let ssoUnavailable = false;

/**
 * Gets an access token for the middle tier API.
 * Tries Office SSO first and falls back to the MSAL login dialog for errors where SSO cannot work
 * (see handleClientSideErrors). Throws for errors that the dialog cannot fix (e.g. 13001, 13002),
 * so callers must handle rejection and stop any loading state.
 */
export async function getMiddletierToken({
  authChallenge,
  interactive = true,
}: MiddletierTokenOptions = {}): Promise<string> {
  if (!ssoUnavailable) {
    try {
      return await OfficeRuntime.auth.getAccessToken({
        forMSGraphAccess: false,
        ...(authChallenge && { authChallenge }),
      });
    } catch (error: any) {
      if (!handleClientSideErrors(error)) {
        throw error;
      }
      ssoUnavailable = true;
    }
  }
  return getAccessTokenViaDialog(interactive);
}
